import React  from 'react';
import { Form, Input } from 'antd';

const { Item } = Form;

const AddressCityFormItem = () => {
  return (
    <Item 
      name="address.city"
      label="Ville"
      wrapperCol={{ span: 15 }}
      labelCol={{ span: 9 }}
    >
      <Input/>
    </Item>
  );
};

export default AddressCityFormItem;
